import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DashboardIndicadores } from '../..';

@Injectable({ providedIn: 'root' })
export class DashboardIndicadoresDiariosService {
    private url = `${environment.managerURL}/dashboard`;
    constructor(private http: HttpClient) {}

    getIndicadoresDiarios(): Observable<DashboardIndicadores> {
        return this.http.get<DashboardIndicadores>(`${this.url}/indicadores-diarios`);
    }
}
